import React, { useState } from 'react';
import { BarChart, Bar, LineChart, Line, PieChart, Pie, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from 'recharts';
import useChartData from './useChartData'; // Import your custom hook

const ExampleChart = ({ data }) => {
    const [groupBy, setGroupBy] = useState(['subCategory', 'typeOfUse', 'constructionYear', 'category', 'defectDescription']);
    const [operation, setOperation] = useState('count');
    const [chartType, setChartType] = useState('bar');

  const chartData = useChartData(data, groupBy, operation, chartType);

  const handleGroupByChange = (event) => {
    setGroupBy(event.target.value);
  };

  const handleOperationChange = (event) => {
    setOperation(event.target.value);
  };

  const handleChartTypeChange = (event) => {
    setChartType(event.target.value);
  };

  return (
    <div>
      <h1>Example Chart</h1>
      <div>
      <label>
          Group By:
          <select
            multiple
            value={groupBy}
            onChange={(event) => setGroupBy(Array.from(event.target.selectedOptions, (option) => option.value))}
          >
            <option value="subCategory">Sub Category</option>
            <option value="typeOfUse">Type of Use</option>
            <option value="constructionYear">Construction Year</option>
            <option value="category">Category</option>
            <option value="defectDescription">Defect Description</option>
            {/* Add more options as needed */}
          </select>
        </label>

        <label>
          Operation:
          <select value={operation} onChange={handleOperationChange}>
            <option value="count">Count</option>
            <option value="sum">Sum</option>
            {/* Add more options as needed */}
          </select>
        </label>
        <label>
          Chart Type:
          <select value={chartType} onChange={handleChartTypeChange}>
            <option value="bar">Bar Chart</option>
            <option value="line">Line Chart</option>
            <option value="pie">Pie Chart</option>
            {/* Add more options (e.g., area, composed, scatter, radar, radialBar, treemap) as needed */}
          </select>
        </label>
      </div>
      <div>
        {/* Render the appropriate Recharts component based on chartType */}
        {chartType === 'bar' && (
          <BarChart width={600} height={400} data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="group" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="value" fill="#8884d8" />
          </BarChart>
        )}
        {chartType === 'line' && (
          <LineChart width={600} height={400} data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="group" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="value" stroke="#8884d8" />
          </LineChart>
        )}
        {chartType === 'pie' && (
          <PieChart width={600} height={400}>
            <Pie data={chartData} dataKey="value" nameKey="group" cx="50%" cy="50%" outerRadius={80} fill="#8884d8" label />
            <Tooltip />
            <Legend />
          </PieChart>
        )}
        {/* Add more Recharts components for other chart types as needed */}
      </div>
    </div>
  );
};

export default ExampleChart;
